import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../Translate';

const FormInputHOC = (C) => {
  const FormInput = (props) => {
    const {
      errorText,
      rootClass,
      showError,
      ...componentProps
    } = props;
    const rootClasses = [rootClass];
    if (errorText) {
      rootClasses.push(`${rootClasses[0]}--error`);
    }

    return (
      <div className={rootClasses.join(' ')}>
        <C {...componentProps} />
        {showError && errorText ? (
<ul className="error-list">
          <Translate component="li" content={errorText} />
</ul>
        ): null}
      </div>
    );
  };

  FormInput.defaultProps = {
    rootClass: 'form-input',
    showError: true,
  };

  FormInput.PropTypes = {
    showError:PropTypes.bool,
    errorText:PropTypes.string,
    rootClass:PropTypes.string,
  };

  return FormInput;
};

export default FormInputHOC;
